"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RADIO_AND_CHECKBOX_SIZES = void 0;
const RADIO_AND_CHECKBOX_SIZES = exports.RADIO_AND_CHECKBOX_SIZES = {
  S: 24,
  M: 28,
  L: 40
};